import { Opportunity } from "@entities";
import { TextField } from "@mui/material";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";
import { useState } from "react";
import { BasicButton } from "../../components/generic-components/button/Button";

/**
 * Filter opportunities by their minAge / maxAge requirement fields.
 * - גיל מינימלי → minAge >= value
 * - גיל מקסימלי → maxAge <= value
 */
export const opportunityAgeRangeFilter: HyperTableFilter<Opportunity> = {
  id: "ageRange",
  icon: "string",
  caption: "גיל",
  renderFilter: ({ onSave, meta }) => {
    const [state, setState] = useState({
      minAge: (meta?.minAge as string) || "",
      maxAge: (meta?.maxAge as string) || "",
    });

    const handleSave = () => {
      const conditions: Array<Record<string, unknown>> = [];

      if (state.minAge !== "") {
        const min = Number(state.minAge);
        if (Number.isFinite(min)) {
          conditions.push({ minAge: { $gte: min } });
        }
      }

      if (state.maxAge !== "") {
        const max = Number(state.maxAge);
        if (Number.isFinite(max)) {
          conditions.push({ maxAge: { $lte: max } });
        }
      }

      const value =
        conditions.length === 0
          ? {}
          : conditions.length === 1
            ? Opportunity.hyperFilter(conditions[0])
            : Opportunity.hyperFilter({ $and: conditions });

      onSave({ value, meta: state });
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          paddingInline: "0.5rem",
        }}
      >
        <TextField
          type="number"
          label="גיל מינימלי"
          value={state.minAge}
          onChange={(e) =>
            setState({
              ...state,
              minAge: e.target.value,
            })
          }
          inputProps={{ min: 0, max: 120 }}
          size="small"
        />
        <TextField
          type="number"
          label="גיל מקסימלי"
          value={state.maxAge}
          onChange={(e) =>
            setState({
              ...state,
              maxAge: e.target.value,
            })
          }
          inputProps={{ min: 0, max: 120 }}
          size="small"
        />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <BasicButton
            style={{
              borderRadius: "10px",
              backgroundColor: "#05204c",
              padding: "0.3rem 1rem",
              fontWeight: 400,
              fontSize: "small",
            }}
            text="שמירה"
            onClick={handleSave}
          />
        </div>
      </div>
    );
  },
};
